import { CSSObject } from '@chakra-ui/react';

export const Accordion: CSSObject = {
  border: 'none',
  overflow: 'hidden',
  bg: 'gray.200',
  borderRadius: 'md',

  '.chakra-accordion__item': {
    _first: {
      borderTop: '0',
    },
    _last: {
      borderBottom: '0',
    },
  },

  '.chakra-accordion__panel': {
    color: 'gray.600',
  },
};

export const AccordionHeader: CSSObject = {
  bg: 'gamma.200',
  color: 'beta.600',
  transitionDuration: 'normal',
  transitionProperty: 'common',
  boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.20)',

  svg: {
    _last: {
      color: 'beta.600',
    },
  },

  _hover: {
    bg: 'gamma.300',
    color: 'white',
  },
  _focus: {
    bg: 'gamma.300',
    color: 'white',
  },
};

export const OverviewPromotionsPanel: CSSObject = {
  color: 'beta.600',
  '&&': {
    '.chakra-checkbox__label': {
      color: 'gray.600',
    },
  },
};

export const AccordionHeaderLogOut: CSSObject = {
  borderColor: 'delta.300',
  color: 'white',
  borderRadius: 'base',

  _hover: {
    bg: 'gamma.300',
    color: 'white',
  },
  _focus: {
    bg: 'gamma.300',
    color: 'white',
  },
};

export const IconPerson: CSSObject = {
  boxSize: ['5', null, '6'],
  color: 'beta.600',
  mr: '1.5',
};

export const TextAccordion: CSSObject = {
  fontSize: ['xs', null, 'sm'],
  fontWeight: 'semibold',
  mr: 'auto',
  color: 'beta.600',
};

export const FlexContactToChange: CSSObject = {
  alignItems: 'center',
  // TODO: Update to use relevant chakra token
  bg: '#515A59',
  borderRadius: 'base',
  boxShadow: '0px 4px 5px 0px rgba(0, 0, 0, 0.10)',
  color: 'white',
  fontSize: 'xs',
  gap: '1',
  p: '2',
};
